import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";

import SecFooter from "../Layouts/SecFooter";
import SiteNav from "../Layouts/SiteNav";

import Notifications from "../Notifications/Notifications";
import ProfileSidebar from "../ProfileSidebar/ProfileSidebar";
import ProfileFeedback from "../ProfileFeedback/ProfileFeedback";
import TimeoutTimer from "./TimeoutTimer";
import LicenseTermModal from "../Licensing/LicenseTermsModal";
import AnnouncementsModal from "../Announcements/AnnouncementsModal";
import SingleAnnouncementModal from "../Announcements/SingleAnnouncementModal";

import {
  signoutUser,
  closeAnnouncement,
  signInWithAccessToken,
  updateUserLang,
} from "../../actions/UserActions";
import { updateTranslation } from "../../actions/TranslationActions";
import Paths from "../../constants/Paths";
import {
  updateUserProfile,
  getNotifications,
  deleteNotifications,
} from "../../services/Management/UserProfileService";
import { getAnnouncementsForDisplay } from "../../services/Management/AnnouncementService";

class SecLayout extends Component {
  state = {
    NotificationsDisplayed: false,
    ProfileSidebarDisplayed: false,
    ProfileFeedbackDisplayed: false,
    SidebarHiding: false,
    Notifications: [],
    UserProfile: null,
    noteBounceAnim: false,
    Announcements: [],
    isMounted: false,
    LicenseTermsDisplayed: false,
    AnnouncementModalDisplayed: false,
  };

  hideSidebar = () => {
    this.setState({ SidebarHiding: true });
    setTimeout(() => {
      this.setState({
        NotificationsDisplayed: false,
        ProfileSidebarDisplayed: false,
        ProfileFeedbackDisplayed: false,
        SidebarHiding: false,
      });
    }, 275);
  };
  handleNotifications = (e) => {
    e.preventDefault();
    if (!this.state.NotificationsDisplayed)
      this.setState({
        ProfileSidebarDisplayed: false,
        ProfileFeedbackDisplayed: false,
        NotificationsDisplayed: !this.state.NotificationsDisplayed,
      });
    else {
      this.hideSidebar();
    }
  };
  handleProfileSidebar = (e) => {
    e.preventDefault();
    if (!this.state.ProfileSidebarDisplayed)
      this.setState({
        NotificationsDisplayed: false,
        ProfileFeedbackDisplayed: false,
        ProfileSidebarDisplayed: !this.state.ProfileSidebarDisplayed,
      });
    else {
      this.hideSidebar();
    }
  };
  handleProfileFeedback = (e) => {
    e.preventDefault();
    if (!this.state.ProfileFeedbackDisplayed)
      this.setState({
        NotificationsDisplayed: false,
        ProfileSidebarDisplayed: false,
        ProfileFeedbackDisplayed: !this.state.ProfileFeedbackDisplayed,
      });
    else {
      this.hideSidebar();
    }
  };

  toggleLicenseModal = () => {
    {
      this.setState({
        LicenseTermsDisplayed: !this.state.LicenseTermsDisplayed,
      });
    }
  };

  toggleAnnouncementModal = () => {
    this.setState({
      AnnouncementModalDisplayed: !this.state.AnnouncementModalDisplayed,
    });
  };

  DeleteNotificationsById = (ids) => {
    deleteNotifications(ids).then(() => {
      getNotifications(this.props.User.uid).then((res) => {
        this.setState({
          Notifications: res,
        });
      });
    });
  };

  Langs = {
    0: "en",
    1: "nl",
    2: "fr",
    3: "pl",
  };
  async componentDidMount() {
    const { User } = this.props;

    this.setState({ UserProfile: User.UserProfile });

    if (!(User && User.isAuthenticated)) {
      if (this.props.match.params["token"]) {
        await this.props.signInWithAccessToken(
          this.props.match.params["token"],
          (isAuthenticated) => {
            if (!isAuthenticated) this.props.history.push(Paths.Login);
          }
        );
      } else {
        this.props.history.push(Paths.Login);
      }
    }

    if (User && !(User.userStatus === "0" || User.userStatus === "2")) {
      this.state.UserProfile &&
        this.props.updateLang(
          !this.Langs[this.state.UserProfile.language]
            ? "en"
            : this.Langs[this.state.UserProfile.language]
        );

      if (this.props.condition && !this.props.condition(User)) {
        this.setState({
          subComponent: (
            <Redirect
              to={{
                pathname: "/unauthorized",
              }}
            />
          ),
        });
      } else {
        this.setState({
          subComponent: (
            <this.props.children
              {...this.props}
              UserProfile={
                this.state.UserProfile
                  ? this.state.UserProfile
                  : User.UserProfile
              }
            ></this.props.children>
          ),
        });
      }

      this.callMessages();
      clearInterval(this.interval);
      this.interval = setInterval(() => this.callMessages(), 1000 * 60);
    } else {
      this.props.history.push(Paths.ResetPassword);
    }
    this.setState({ isMounted: true });
  }

  callMessages = () => {
    const { User, announcementBroadcastDestinations } = this.props;
    if (this.props.notificationsActive) {
      const notenum = this.state.Notifications.length;
      getNotifications(User.uid).then((res) => {
        this.setState({ Notifications: res });
        if (notenum !== res.length) {
          this.setState({ noteBounceAnim: true });
          setTimeout(() => {
            this.setState({ noteBounceAnim: false });
          }, 1000);
        }
      });
    }
    getAnnouncementsForDisplay({
      broadcastDestinations: announcementBroadcastDestinations || [
        0,
      ] /*Global */,
    }).then((res) => {
      this.setState({ Announcements: res });
    });
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const {
      _,
      logo,
      signoutUser,
      pages,
      notificationsActive,
      siteName,
      User,
      siteConfigurations,
      applicationType,
    } = this.props;
    const logout = () => {
      signoutUser();
    };

    const mostImportantAnnouncementType = () => {
      if (!this.state.Announcements && this.state.Announcements.length === 0) {
        return "";
      } else {
        // Backend returns most important first, so just get type from first element
        var announcementTypeFromFirst =
          this.state.Announcements[0].announcementType;

        return announcementTypeFromFirst === 0
          ? "important"
          : announcementTypeFromFirst === 1
          ? "warning"
          : "information";
      }
    };

    return !this.state.isMounted ? (
      <div></div>
    ) : !(User && User.isAuthenticated) ? (
      <Redirect to={Paths.Login} />
    ) : (
      <div className="d-flex flex-nowrap secure-layout">
        <TimeoutTimer siteName={siteName} logout={logout} />
        {this.state.LicenseTermsDisplayed ? (
          <LicenseTermModal openCloseModal={this.toggleLicenseModal} _={_} />
        ) : (
          []
        )}
        <SiteNav
          {...this.props}
          pages={pages}
          noteBounceAnim={this.state.noteBounceAnim}
          notificationNum={
            this.state.Notifications ? this.state.Notifications.length : 0
          }
          hideSidebar={this.hideSidebar}
          userprofileState={this.state.ProfileSidebarDisplayed}
          feedbackState={this.state.ProfileFeedbackDisplayed}
          notificationsState={this.state.NotificationsDisplayed}
          notificationsActive={notificationsActive}
          handleNotifications={this.handleNotifications}
          handleProfileSidebar={this.handleProfileSidebar}
          handleProfileFeedback={this.handleProfileFeedback}
        />
        {this.state.NotificationsDisplayed && notificationsActive && (
          <Notifications
            handleNotifications={this.handleNotifications}
            Notifications={this.state.Notifications}
            DeleteNotificationsById={this.DeleteNotificationsById}
            SidebarHiding={this.state.SidebarHiding}
          />
        )}
        {this.state.ProfileSidebarDisplayed && (
          <ProfileSidebar
            handleProfileSidebar={this.handleProfileSidebar}
            canChangePassword={() => siteConfigurations.canChangePassword(User)}
            SignoutUser={logout}
            _={this.props._}
            UserProfile={{
              ...this.state.UserProfile,
              UpdateValue: (e) => {
                this.setState({
                  UserProfile: {
                    ...this.state.UserProfile,
                    [e.target.name.replace(/\s/g, "")]: e.target.value,
                  },
                });
              },
              SaveProfileDetails: () => {
                const updatedProfile = this.state.UserProfile;
                updateUserProfile(updatedProfile);
                this.props.updateUserLang(updatedProfile.language);
                this.props.updateLang(
                  !this.Langs[updatedProfile.language]
                    ? "en"
                    : this.Langs[updatedProfile.language]
                );
              },
            }}
            SidebarHiding={this.state.SidebarHiding}
          />
        )}
        {this.state.ProfileFeedbackDisplayed && (
          <ProfileFeedback
            handleProfileFeedback={this.handleProfileFeedback}
            SidebarHiding={this.state.SidebarHiding}
            User={this.state.UserProfile}
            applicationType={applicationType}
          />
        )}
        <main className="main-content flex-grow-1">
          {this.state.Announcements &&
            this.state.Announcements.length > 0 &&
            this.props.User.ShowAnnouncement && (
              <div className="announcements">
                <div
                  className="announcement-bar"
                  onClick={this.toggleAnnouncementModal}
                >
                  <div className="colour-area">
                    <div className={mostImportantAnnouncementType()}>
                      <i className="icon-omni-warning-circle" />
                    </div>
                  </div>
                  <div className="announcement-text">
                    <span className={mostImportantAnnouncementType()}>
                      {this.state.Announcements.length > 1
                        ? this.props._.ThereAre +
                          this.state.Announcements.length +
                          this.props._.ActiveAnnouncements
                        : this.state.Announcements[0].title}
                    </span>
                  </div>
                  <div
                    className={mostImportantAnnouncementType() + "-close-area"}
                  >
                    <button
                      className="btn"
                      onClick={() => this.props.closeAnnouncement()}
                    >
                      <i className="icon-omni-close-circle" />
                    </button>
                  </div>
                </div>
              </div>
            )}

          {this.props.User.ShowAnnouncement &&
            this.state.AnnouncementModalDisplayed &&
            this.state.Announcements.length === 1 && (
              <SingleAnnouncementModal
                announcement={this.state.Announcements[0]}
                openCloseModal={this.toggleAnnouncementModal}
                _={_}
              />
            )}

          {this.props.User.ShowAnnouncement &&
            this.state.AnnouncementModalDisplayed &&
            this.state.Announcements.length > 1 && (
              <AnnouncementsModal
                announcements={this.state.Announcements}
                openCloseModal={this.toggleAnnouncementModal}
                mostImportantAnnouncementType={mostImportantAnnouncementType()}
                _={_}
              />
            )}

          {!(
            this.props.User &&
            (this.props.User.userStatus === "0" ||
              this.props.User.userStatus === "2")
          ) &&
            this.state.subComponent &&
            this.state.subComponent}
          <SecFooter
            _={_}
            logo={logo}
            viewLicenseDisplay={this.toggleLicenseModal}
          />
        </main>
      </div>
    );
  }
}

export default connect(
  (state) => state,
  (dispatch) => ({
    signoutUser: () => dispatch(signoutUser()),
    signInWithAccessToken: (token, cb) =>
      dispatch(signInWithAccessToken(token, cb)),
    updateLang: (lang) => dispatch(updateTranslation(lang)),
    updateUserLang: (lang) => dispatch(updateUserLang(lang)),
    closeAnnouncement: () => dispatch(closeAnnouncement()),
  })
)(withRouter(SecLayout));
